import type { Message } from '@gitlab-org/tui';

/**
 * Computes the not-yet-sent suffix of an assistant message's accumulated
 * content and records the new send position, so repeated calls for the same
 * `message.id` as content grows only ever return the incremental delta.
 *
 * Returns undefined when there is nothing new to send (e.g. the same message
 * observed twice with no additional content).
 */
export function computeMessageDelta(
  message: Message,
  sentTextLength: Map<string, number>,
): string | undefined {
  const alreadySent = sentTextLength.get(message.id) ?? 0;
  const delta = message.content.slice(alreadySent);
  if (!delta) return undefined;

  sentTextLength.set(message.id, message.content.length);
  return delta;
}
